import React from "react";
const NoDataFoundComponent = () => {
  return (
    <div style={{ textAlign: "center", padding: "20px", fontWeight: "bold" }}>
      Sorry! Nothing To Show
    </div>
  );
};

export default NoDataFoundComponent;